(function () {
  if (window.MMSubscriptionPopup) {
    window.MMSubscriptionPopup.init();
    return;
  }

  var activeController = null;

  function init() {
    var popup = document.getElementById('mm-subscription-popup');
    if (activeController && activeController.element === popup) return;
    if (activeController) activeController.destroy();
    activeController = null;
    if (!popup || popup.dataset.enabled !== 'true') return;

    var dialog = popup.querySelector('.mm-sub-popup__dialog');
    var overlay = popup.querySelector('[data-mm-popup-overlay]');
    var closeButton = popup.querySelector('[data-mm-popup-close]');
    var cta = popup.querySelector('[data-mm-popup-cta]');
    if (!dialog || !overlay || !closeButton || !cta) return;

    var campaignId = popup.dataset.campaignId || 'mm-sub-club-v2-20261003';
    var delaySeconds = Number.parseInt(popup.dataset.delaySeconds || '15', 10);
    var delayMs = Number.isFinite(delaySeconds) ? Math.max(delaySeconds, 5) * 1000 : 15000;
    var localeRoot = (popup.dataset.localeRoot || '/').replace(/\/+$/, '');
    var seenKey = 'mmSubPopupSeen:' + campaignId;
    var dismissedKey = 'mmSubPopupDismissed:' + campaignId;
    var clickedKey = 'mmSubPopupClicked:' + campaignId;
    var sessionKey = 'mmSubPopupSessionShown:' + campaignId;
    var timerId = null;
    var frameId = null;
    var shown = false;
    var displayed = false;
    var seenThisPage = false;
    var lastFocusedElement = null;
    var pagePosition = { x: 0, y: 0 };
    var inerted = [];

    function emit(name, details) {
      try {
        if (!window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.()) return;
        var payload = { event: name, campaign_id: campaignId, locale: document.documentElement.lang || 'en' };
        if (details && details.trigger) payload.trigger = details.trigger;
        if (details && details.method) payload.dismiss_method = details.method;
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(payload);
      } catch (error) { return; }
    }

    function readStorage(key, session) {
      try { return (session ? window.sessionStorage : window.localStorage).getItem(key); }
      catch (error) { return null; }
    }

    function writeStorage(key, value, session) {
      try { (session ? window.sessionStorage : window.localStorage).setItem(key, value); }
      catch (error) { return; }
    }

    function recent(key, days) {
      var timestamp = Number.parseInt(readStorage(key, false) || '0', 10);
      return Number.isFinite(timestamp) && timestamp > 0 && Date.now() - timestamp < days * 86400000;
    }

    function excluded() {
      var path = window.location.pathname.replace(/\/+$/, '') || '/';
      if (localeRoot && (path === localeRoot || path.indexOf(localeRoot + '/') === 0)) {
        path = path.slice(localeRoot.length) || '/';
      }
      path = path.replace(/^\/[a-z]{2}(?:-[a-z]{2})?(?=\/|$)/i, '') || '/';
      if (path === '/collections/monthly-hot-wheels-subscription-club-boxes') return true;
      return ['/cart', '/checkout', '/checkouts', '/account', '/orders', '/thank_you', '/policies', '/search', '/password'].some(function (prefix) {
        return path === prefix || path.indexOf(prefix + '/') === 0;
      });
    }

    function rendered(element) {
      if (!element || !element.isConnected || element.closest('[hidden], [inert], [aria-hidden="true"]')) return false;
      var style = window.getComputedStyle(element);
      if (style.display === 'none' || style.visibility === 'hidden' || style.visibility === 'collapse' || Number(style.opacity) === 0) return false;
      return Array.prototype.some.call(element.getClientRects(), function (rect) { return rect.width > 0 && rect.height > 0; });
    }

    function blocked() {
      var active = document.activeElement;
      if (active && active.matches('input, textarea, select, [contenteditable="true"]') && rendered(active)) return true;
      var selectors = [
        'dialog[open]', '[role="dialog"][aria-modal="true"]',
        'details-modal[open]', 'cart-drawer[open]', 'cart-drawer.active',
        '.drawer.active', '.drawer--active', '.modal[open]', '.modal.is-active',
        '.r32-header details[open]', '.shopify-section-header-sticky details[open]',
        '[data-mm-cookie-consent]', '.mc-modal', '.mc-banner', '.smile-panel-frame-container',
        '[data-mm-newsletter-dialog][open]'
      ].join(',');
      return Array.prototype.some.call(document.querySelectorAll(selectors), function (element) {
        if (element === popup || popup.contains(element) || !rendered(element)) return false;
        if (element.matches('details[data-r32-navigation][open]') && element.closest('.r32-header') && element.dataset.open !== 'true') return false;
        if (element.tagName === 'DETAILS' && !rendered(element.querySelector(':scope > summary'))) return false;
        return Array.prototype.some.call(element.getClientRects(), function (rect) {
          return rect.bottom > 0 && rect.right > 0 && rect.top < window.innerHeight && rect.left < window.innerWidth;
        });
      });
    }

    function focusables() {
      return Array.prototype.filter.call(dialog.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'), rendered);
    }

    function focus(element) {
      if (!element || typeof element.focus !== 'function') return;
      try { element.focus({ preventScroll: true }); } catch (error) { element.focus(); }
    }

    function setOpeners(open) {
      document.querySelectorAll('[data-mm-subscription-floating-tab]').forEach(function (opener) {
        opener.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    }

    function isolateBackground() {
      var branch = popup;
      while (branch && branch !== document.body) {
        var parent = branch.parentElement;
        if (!parent) break;
        Array.prototype.forEach.call(parent.children, function (sibling) {
          if (sibling === branch || sibling.inert || /^(SCRIPT|STYLE|LINK)$/.test(sibling.tagName)) return;
          sibling.inert = true;
          inerted.push(sibling);
        });
        branch = parent;
      }
    }

    function restoreBackground() {
      inerted.forEach(function (element) { element.inert = false; });
      inerted = [];
    }

    function close(method, recordDismissal) {
      if (!shown) return;
      if (frameId !== null) window.cancelAnimationFrame(frameId);
      frameId = null;
      shown = false;
      popup.hidden = true;
      popup.setAttribute('aria-hidden', 'true');
      dialog.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('mm-sub-popup-open');
      document.removeEventListener('keydown', onKeydown, true);
      document.removeEventListener('focusin', onFocus, true);
      setOpeners(false);
      restoreBackground();
      if (displayed && recordDismissal !== false) {
        writeStorage(dismissedKey, String(Date.now()), false);
        emit('mm_subscription_popup_dismiss', { method: method });
      }
      displayed = false;
      if (lastFocusedElement && lastFocusedElement.isConnected && rendered(lastFocusedElement)) focus(lastFocusedElement);
      if (window.scrollX !== pagePosition.x || window.scrollY !== pagePosition.y) window.scrollTo(pagePosition.x, pagePosition.y);
    }

    function onFocus(event) {
      if (shown && !dialog.contains(event.target)) focus(closeButton);
    }

    function onKeydown(event) {
      if (!shown) return;
      if (event.key === 'Escape') {
        event.preventDefault();
        event.stopPropagation();
        close('escape');
      } else if (event.key === 'Tab') {
        var items = focusables();
        var first = items[0] || dialog;
        var last = items[items.length - 1] || dialog;
        if (!items.length || !dialog.contains(document.activeElement) || document.activeElement === dialog || (event.shiftKey && document.activeElement === first) || (!event.shiftKey && document.activeElement === last)) {
          event.preventDefault();
          focus(event.shiftKey ? last : first);
        }
      }
    }

    function open(trigger, opener) {
      if (shown || popup.dataset.enabled !== 'true' || excluded() || document.hidden || blocked()) return false;
      popup.hidden = false;
      popup.setAttribute('aria-hidden', 'false');
      dialog.setAttribute('aria-hidden', 'false');
      if (!rendered(dialog)) {
        popup.hidden = true;
        popup.setAttribute('aria-hidden', 'true');
        dialog.setAttribute('aria-hidden', 'true');
        return false;
      }
      lastFocusedElement = opener || document.activeElement;
      pagePosition = { x: window.scrollX, y: window.scrollY };
      shown = true;
      document.body.classList.add('mm-sub-popup-open');
      isolateBackground();
      setOpeners(true);
      document.addEventListener('keydown', onKeydown, true);
      document.addEventListener('focusin', onFocus, true);
      focus(closeButton);
      if (timerId !== null) window.clearTimeout(timerId);
      timerId = null;
      frameId = window.requestAnimationFrame(function () {
        frameId = null;
        if (!shown || document.hidden || !rendered(dialog)) {
          close('not_visible', false);
          return;
        }
        displayed = true;
        seenThisPage = true;
        writeStorage(seenKey, String(Date.now()), false);
        writeStorage(sessionKey, '1', true);
        emit('mm_subscription_popup_view', { trigger: trigger });
        if (trigger === 'manual') emit('mm_subscription_popup_manual_open', { trigger: trigger });
      });
      return true;
    }

    function canAutoOpen() {
      return popup.dataset.enabled === 'true' && !excluded() && !seenThisPage && !readStorage(sessionKey, true) && !recent(clickedKey, 30) && !recent(dismissedKey, 30) && !recent(seenKey, 7);
    }

    function attemptAutoOpen() {
      timerId = null;
      if (!canAutoOpen() || shown || !popup.isConnected) return;
      if (!open('timer')) timerId = window.setTimeout(attemptAutoOpen, 4000);
    }

    function onClick(event) {
      var target = event.target instanceof Element ? event.target : null;
      if (!target) return;
      var opener = target.closest('[data-mm-subscription-floating-tab]');
      if (opener && !event.defaultPrevented && event.button === 0 && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey) {
        if (open('manual', opener)) event.preventDefault();
        return;
      }
      if (!shown || !popup.contains(target)) return;
      if (target.closest('[data-mm-popup-cta]')) {
        writeStorage(clickedKey, String(Date.now()), false);
        emit('mm_subscription_popup_click');
        close('cta', false);
      } else if (target.closest('[data-mm-popup-close]')) close('close_button');
      else if (target.closest('[data-mm-popup-dismiss]')) close('maybe_later');
      else if (target === overlay) close('backdrop');
    }

    document.querySelectorAll('[data-mm-subscription-floating-tab]').forEach(function (opener) {
      if (excluded()) return;
      opener.setAttribute('aria-haspopup', 'dialog');
      opener.setAttribute('aria-controls', 'mm-subscription-popup');
      opener.setAttribute('aria-expanded', 'false');
    });
    document.addEventListener('click', onClick);
    popup.dataset.repairVersion = '2026-10-22.3';
    if (canAutoOpen()) timerId = window.setTimeout(attemptAutoOpen, delayMs);
    activeController = {
      element: popup,
      destroy: function () {
        if (timerId !== null) window.clearTimeout(timerId);
        close('section_unload', false);
        document.removeEventListener('click', onClick);
      }
    };
  }

  window.MMSubscriptionPopup = { init: init };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', function (event) {
    if (activeController && event.target.contains(activeController.element)) {
      activeController.destroy();
      activeController = null;
    }
  });
}());

